/** Full-page navigation. A function of its own so tests can replace it. */
export const go = (path: string): void => window.location.assign(path);
